<template>
  <div class="StepsThird">
    <GroupReportThird :IsDetails="IsDetails" v-if="reportType < 3" ref="GroupReportThird"></GroupReportThird>
    <ContrastReportThird :IsDetails="IsDetails" v-else ref="ContrastReportThird"></ContrastReportThird>
    <div v-if="!IsDetails" style="text-align: right; margin: 30px 0; padding-right: 50px">
      <a-button @click="$parent.$data.current = 1" style="margin-right: 20px">上一步</a-button>
      <!-- <a-button type="primary" :loading="formRelevant.loading" @click="next">生成报告</a-button> -->
      <a-button type="primary" @click="next">下一步</a-button>
    </div>
  </div>
</template>

<script>
import GroupReportThird from '../../components/GroupReportThird'
import ContrastReportThird from '../../components/ContrastReportThird'
export default {
  name: 'StepsThird',
  props: {
    IsDetails: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    GroupReportThird,
    ContrastReportThird,
  },
  data() {
    return {
      reportType: this.$store.getters['organization/getReportInfo'].reportType,
      reportInfo: this.$store.getters['organization/getReportInfo'],
    }
  },
  created() {},
  methods: {
    next() {
      let data = this.reportType < 3 ? this.$refs.GroupReportThird.$data.tableRelevant.tableDataSource : this.$refs.ContrastReportThird.$data.tableRelevant.tableDataSource

      let params = {
        groupReportId: this.reportInfo.id,
        contrastDimension: this.reportType < 3 ? 0 : this.$refs.ContrastReportThird.$data.contrastDimension,
        configs: [],
      }
      this.$store.commit('organization/setReportInfo', {
        ...this.reportInfo,
        contrastDimension: params.contrastDimension,
      })
      this.$message.destroy()
      const itemValue = data.filter((e) => !e.details.length)
      if (itemValue.length > 0) {
        if (this.reportType < 3) {
          this.$message.error('未配置能力，请修改后再操作')
        } else {
          this.$message.error(itemValue[0].sampleName + '未配置能力，请修改后再操作')
        }
        return
      } else {
        data.forEach((v) => {
          let str = {
            groupReportCourseSessionId: '',
            groupReportSampleId: v.groupReportSampleId,
            contentAbilityConfigs: [],
          }
          str.groupReportCourseSessionId = v.groupReportCourseSessionId
          v.details.forEach((m) => {
            m.abilityDetails.forEach((a) => {
              if (a.scoreSwitch) {
                str.contentAbilityConfigs.push(a.abilityId)
              }
            })
          })
          params.configs.push(str)
        })
      }
      this.$http.ReportService.updatContentAbilityConfigs(params).then((res) => {
        const { status, data, message } = res
        this.$parent.$data.current = 3
      })
    },
  },
}
</script>

<style scoped></style>
